import { ReactNode } from 'react';
import { TMaxPlayers, TRoomColors as TRoomColors } from '@api/types/blackjack';

/* CHIPS */

import { ReactComponent as MiamiChipIcon } from '@assets/svg/blackjack/chip-miami.svg';
import { ReactComponent as MonacoChipIcon } from '@assets/svg/blackjack/chip-monaco.svg';
import { ReactComponent as LondonChipIcon } from '@assets/svg/blackjack/chip-london.svg';
import { ReactComponent as MacauChipIcon } from '@assets/svg/blackjack/chip-macau.svg';
import { ReactComponent as MiamiChipNumberIcon } from '@assets/svg/blackjack/chip-miami-number.svg';
import { ReactComponent as MonacoChipNumberIcon } from '@assets/svg/blackjack/chip-monaco-number.svg';
import { ReactComponent as LondonChipNumberIcon } from '@assets/svg/blackjack/chip-london-number.svg';
import { ReactComponent as MacauChipNumberIcon } from '@assets/svg/blackjack/chip-macau-number.svg';

/* TABLES */

import { ReactComponent as MiamiTableIcon } from '@assets/svg/blackjack/miami-table.svg';
import { ReactComponent as MonacoTableIcon } from '@assets/svg/blackjack/monaco-table.svg';
import { ReactComponent as LondonTableIcon } from '@assets/svg/blackjack/london-table.svg';
import { ReactComponent as MacauTableIcon } from '@assets/svg/blackjack/macau-table.svg';

import { ReactComponent as MacauTableCroppedIcon } from '@assets/svg/blackjack/macau-table-cropped.svg';

/* CARDS' BACK */

import { ReactComponent as MacauCardBackIcon } from '@assets/svg/blackjack/macau-card-back.svg';
import { ReactComponent as MonacoCardBackIcon } from '@assets/svg/blackjack/monaco-card-back.svg';

type TRoomNames = {
  // eslint-disable-next-line no-unused-vars
  [key in TMaxPlayers]: string;
};

export interface IChipItem {
  Icon: ReactNode;
  Number: ReactNode;
}

type TRoomChips = {
  // eslint-disable-next-line no-unused-vars
  [key in TMaxPlayers]: IChipItem;
};

export interface IRoomTableItem {
  full: ReactNode;
  cropped: ReactNode;
}

type TRoomTables = {
  // eslint-disable-next-line no-unused-vars
  [key in TMaxPlayers]: IRoomTableItem;
};

type TRoomCardsBack = {
  // eslint-disable-next-line no-unused-vars
  [key in TMaxPlayers]: ReactNode;
};

interface IRoomProperties {
  COLORS: TRoomColors;
  NAMES: TRoomNames;
  CHIPS: TRoomChips;
  TABLES: TRoomTables;
  CARDS_BACK: TRoomCardsBack;
}

const ROOM_COLORS: TRoomColors = {
  2: 'miami',
  3: 'monaco',
  4: 'london',
  5: 'macau',
  6: 'singapore',
  7: 'las-vegas',
};

const ROOM_NAMES: TRoomNames = {
  2: 'Miami',
  3: 'Monaco',
  4: 'London',
  5: 'Macau',
  6: 'Singapore',
  7: 'Las Vegas',
};

const ROOM_CHIPS: TRoomChips = {
  2: {
    Icon: <MiamiChipIcon />,
    Number: <MiamiChipNumberIcon />,
  },
  3: {
    Icon: <MonacoChipIcon />,
    Number: <MonacoChipNumberIcon />,
  },
  4: {
    Icon: <LondonChipIcon />,
    Number: <LondonChipNumberIcon />,
  },
  5: {
    Icon: <MacauChipIcon />,
    Number: <MacauChipNumberIcon />,
  },
  6: {
    Icon: <MacauChipIcon />,
    Number: <MacauChipNumberIcon />,
  },
  7: {
    Icon: <MacauChipIcon />,
    Number: <MacauChipNumberIcon />,
  },
};

const ROOM_TABLES: TRoomTables = {
  2: {
    full: <MiamiTableIcon />,
    cropped: <MacauTableCroppedIcon />,
  },
  3: {
    full: <MonacoTableIcon />,
    cropped: <MacauTableCroppedIcon />,
  },
  4: {
    full: <LondonTableIcon />,
    cropped: <MacauTableCroppedIcon />,
  },
  5: {
    full: <MacauTableIcon />,
    cropped: <MacauTableCroppedIcon />,
  },
  6: {
    full: <MiamiTableIcon />,
    cropped: <MacauTableCroppedIcon />,
  },
  7: {
    full: <MiamiTableIcon />,
    cropped: <MacauTableCroppedIcon />,
  },
};

const ROOM_CARDS: TRoomCardsBack = {
  2: <MonacoCardBackIcon />,
  3: <MonacoCardBackIcon />,
  4: <MonacoCardBackIcon />,
  5: <MacauCardBackIcon />,
  6: <MacauCardBackIcon />,
  7: <MacauCardBackIcon />,
};

export const ROOM: IRoomProperties = {
  COLORS: ROOM_COLORS,
  NAMES: ROOM_NAMES,
  CHIPS: ROOM_CHIPS,
  TABLES: ROOM_TABLES,
  CARDS_BACK: ROOM_CARDS,
};

export const PLAYER_NOT_FOUND = -1;
